<script setup lang="ts">
// This component is used to select one of the different ContentColor values.
// In the future, we could extend this to allow for more complex color selections,
// like custom colors, and a prop to define the type of color (background, text, etc.)
// to give the user more useful options + also more control.

import { ContentColor } from '#imports'

const { name, label } = defineProps<{
  name: string
  label: string
}>()

const colorVariants = Object.values(ContentColor)

</script>

<template>
  <FormListField
    :name="name"
    :label="label"
    :items="colorVariants"
    :label-factory="(variant: ContentColor) => variant"
  />
</template>
